export default "__VITE_ASSET__CmWPIStM__"